module.exports = __webpack_public_path__ + "static/img/PU SKIN products discription1_deskstop.63260c99.jpg";